<template>
  <div>
    <v-col class="px-0 pt-0" cols="12" md="12">
      <v-card class="services-card" outlined>
        <v-card-text>
          <v-row>
             <v-col cols="12" md="12" class="pt-3">
              <span class="info-text">{{ infoText }}</span>
             </v-col>
            <v-col cols="12" md="12">
              <h3 style="display: flex;">
                {{
                  $t(
                    'Veiksmai, kuriems atlikti ir paslaugos, kurioms gauti išduotas įgaliojimas'
                  )
                }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Veiksmai kuriems atlikti ir paslaugos kurioms gauti išduotas įgaliojimas" subTitle></el-tooltip>
              </h3>
            </v-col>
            <v-col class="py-0" cols="12" md="12">
              <el-textarea
                label="Veiksmo ar paslaugos aprašymas"
                tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Veiksmo ar paslaugos aprašymas"
                required
                v-model="formCustomData.service"
                :maxlength="2000"
              />
            </v-col>
            <v-col class="py-0" cols="12" md="12">
              <h4 style="display: flex;">
                {{
                  $t(
                    'Asmuo, kurio paslaugomis gauti ar kurio atžvilgiu veiksmams atlikti išduotas įgaliojimas'
                  )
                }}
                <el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Asmuo, kurio paslaugoms gauti ar kurio atžvilgiu veiksmams atlikti išduotas įgaliojimas" subTitle></el-tooltip>
              </h4>
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="12">
              <el-radio-group
              class="mt-1 pt-0"
                @change="onInstitutionChange()"
                v-model="formCustomData.service_provider"
                :items="customServices"
                required
              >
              </el-radio-group>
            </v-col>
            <v-col v-if="showCustomAddProvider" class="pt-2" cols="12" md="4">
              <el-button
                block
                title="Ieškoti paslaugų teikėjo"
                :loading="loading"
                @click.native="addServiceProviderModal()"
                color="secondary"
                icon="ieškoti"
              />
            </v-col>
            <template v-if="showInstitutionData">
              <v-col class="pb-0" cols="12" md="6"></v-col>
              <v-col class="pb-0" cols="12" md="6">
                <el-textarea
                  label="Asmens kodas"
                  disabled
                  v-model="formCustomData.institution.code"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="6"></v-col>
              <v-col class="pb-0" cols="12" md="12">
                <el-textarea
                  label="Pavadinimas"
                  disabled
                  v-model="formCustomData.institution.fullname"
                />
              </v-col>
              <v-col class="pb-0" cols="12" md="12">
                <el-textarea
                  label="Kita informacija"
                  disabled
                  v-model="formCustomData.institution.other_info"
                />
              </v-col>
            </template>
            <template v-else-if="showServiceProviderAmn">
              <v-col class="pb-0" cols="12" md="12">
                <el-textarea
                  label="Paslaugų teikėjas"
                  disabled
                  v-model="formCustomData.service_provider_amn"
                />
              </v-col>
            </template>
            <v-col style="text-align: end" cols="12" md="12">
              <el-button
                title="Pridėti paslaugą"
                icon="pridėti"
                @click.native.stop="addCustomData()"
                color="primary"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
export default {
  name: 'CustomServicesCard',
  props: {
    formCustomData: [Object, Boolean, String, Number],
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      loading: false,
    }
  },
  created() {
    this.setDefault()
  },

  computed: {
    infoText(){
      return this.$t('Registrų centras, registruodamas el. įgaliojimus, įgaliojimo teisėtumo netikrina. Už įgaliojimo pavedimo turinį atsako įgaliotojas. Institucija, įstaiga ar asmuo, kuriam pateikiamas įgaliojimas, sprendžia, ar įgaliojimas atitinka teisės aktuose nustatytos formos ir turinio reikalavimus, todėl, jei įgaliojimui sudaryti nenaudojate paslaugų klasifikatoriaus, prieš sudarant įgaliojimą, turite įsitikinti, ar Jūsų norimiems atlikti veiksmams toje institucijoje nėra reikalaujamas notarine tvarka patvirtintas įgaliojimas. Taip pat įsitikinkite, ar el. įgaliojimas bus priimtinas toje institucijoje, nes gali būti, kad atitinkamos institucijos informacinės sistemos nėra parengtos atpažinti ir interpretuoti el. įgaliojimų.')
    },
    showServiceProviderAmn() {
      return this.formCustomData?.service_provider_amn
    },
    showInstitutionData() {
      return this.formCustomData?.institution
        ? Object.keys(this.formCustomData.institution).length != 0
        : false
    },
    showCustomAddProvider() {
      return this.formCustomData.service_provider == 'amn'
    },
    customServices() {
      return [
        {
          label: 'Bet kuris juridinis asmuo',
          value: 'unidentified-juridical',
          tooltip: 'IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Neidentifikuotas juridinis asmuo'
        },
        {
          label: 'Bet kuris fizinis asmuo',
          value: 'unidentified-physical',
          tooltip: 'IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Neidentifikuotas fizinis asmuo'
        },
        {
          label: 'Bet kuris fizinis arba juridinis asmuo',
          value: 'unidentified-physical-juridical',
          tooltip: 'IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Neidentifikuotas fizinis arba juridinis asmuo'
        },
        { 
          label: 'Ieškoti paslaugų teikėjo', 
          value: 'amn',
          tooltip: 'IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. Ieškoti paslaugų teikėjo'
        },
        
      ]
    },
    elValue: {
      get() {
        return this.item
      },
      set(elValue) {
        this.$emit('item', elValue)
      },
    },
  },
  methods: {
    setDefault(){
       this.$set(this.formCustomData, 'service_provider', 'amn')
    },
    clearCustomData() {
      this.$nextTick(() => {
        this.setDefault()
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },
    addCustomData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.$emit('addCustomData')
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    addServiceProviderModal() {
      this.$emit('addServiceProviderModal')
    },
    onInstitutionChange() {
      if (this.formCustomData.service_provider != 'amn') {
        this.$set(this.formCustomData, 'institution', {})
        this.$set(this.formCustomData, 'service_provider_amn_id', null)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.info-text{
 color: red;
 font-style: italic;
}
</style>
